/* DERMALINK — tracking การคลิกปุ่มช่องทางร้านค้าในหน้าสินค้า
   ยิง event Click_Shopee / Click_Lazada / Click_Tiktok ไปที่ dataLayer, Meta Pixel (fbq), TikTok Pixel (ttq)
   ใช้ delegated click จึงผูก listener ครั้งเดียว แม้ snippet ถูก render หลายรอบ */
(function () {
  'use strict';
  if (window.__dmlMarketplaceBound) return;
  window.__dmlMarketplaceBound = true;

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-dml-marketplace-link]') : null;
    if (!a) return;

    var market = a.getAttribute('data-dml-marketplace-link'); // shopee | lazada | tiktok
    var root = a.closest('[data-dml-marketplace]') || {};
    var d = root.dataset || {};
    var eventName = 'Click_' + market.charAt(0).toUpperCase() + market.slice(1);

    var payload = {
      marketplace: market,
      link_kind: a.getAttribute('data-marketplace-kind') || 'product',
      content_ids: d.productId ? [String(d.productId)] : undefined,
      content_name: d.productTitle,
      content_category: d.productVendor,
      link_url: a.href
    };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'dml_' + eventName, dml_event: eventName }, payload));
    } catch (err) {}
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, payload);
    } catch (err) {}
    try {
      if (window.ttq && typeof window.ttq.track === 'function') {
        window.ttq.track('ClickButton', { content_id: d.productId, content_name: d.productTitle, description: eventName });
      }
    } catch (err) {}
  }, true);
})();

/* DERMALINK — อัปเดตราคาสดจาก cache (bot อ่านล่าสุด) มาทับปุ่ม */
(function () {
  'use strict';
  function fmt(n) { return Number(n).toLocaleString('en-US') + ' THB'; }
  function ago(iso) {
    if (!iso) return '';
    var mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
    if (mins < 1) return 'เมื่อสักครู่';
    if (mins < 60) return mins + ' นาทีที่แล้ว';
    var h = Math.round(mins / 60);
    return h + ' ชม.ที่แล้ว';
  }
  function apply(root) {
    var ep = (root.getAttribute('data-prices-endpoint') || '').replace(/\/+$/, '');
    var handle = root.getAttribute('data-handle') || '';
    if (!ep || !handle || root.__dmlLive) return;
    root.__dmlLive = true;
    fetch(ep + '/marketprices?handle=' + encodeURIComponent(handle))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok || !j.item) return;
        var changed = 0;
        ['shopee', 'lazada', 'tiktok'].forEach(function (ch) {
          var info = j.item[ch];
          if (!info || !info.price) return;
          var btn = root.querySelector('[data-dml-marketplace-link="' + ch + '"]');
          if (!btn) return;
          var pel = btn.querySelector('.marketplace-buttons__price');
          if (pel) { pel.textContent = fmt(info.price); btn.setAttribute('data-live', '1'); changed++; }
        });
        if (changed) {
          var note = root.querySelector('.marketplace-buttons__note') || root;
          var live = document.createElement('div');
          live.className = 'marketplace-buttons__live';
          live.textContent = 'ราคาอัปเดตล่าสุด ' + ago(j.updatedAt);
          (root.querySelector('.marketplace-buttons__note') || root).appendChild(live);
        }
      })
      .catch(function () {});
  }
  function boot() { document.querySelectorAll('[data-dml-marketplace][data-prices-endpoint]').forEach(apply); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
